import svg from '../assets/images/notfound.svg'
export default function NotFound() {
    return (
        <div className='p-d-flex p-jc-center p-ai-center' style={{ height: '100vh' }}>
            <img alt='Não encontrado.' src={svg} width="800px" height="100%" draggable="false" />
        </div>
    )
}